<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.grupos"
                    :validations="validations.grupo"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    max: 100,
                    min: 3,
                },
                grupo: {
                    required: true,
                },
            }
        },
    },
    created() {

        this.repositories = {
            grupo: this.getConectaSusRepository('cadastro.grupo'),
            subgrupo: this.getConectaSusRepository('cadastro.subgrupo')
        }

        this.load()
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.subgrupo.edit(this.id)
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.subgrupo.create()
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.subgrupo.update(this.id, this.prepareData())
                        : this.repositories.subgrupo.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.model)
        },
    },
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number }
    },
}
</script>